import React from "react";
import styles from "./index.module.css";
import cyLogo from "../../assets/cy_logo.png";
import catalystLogo from "../../assets/catalyst_new.png";
import { isCatalyst } from "../../utils/brandConfig";

const Header = ({ businessUnitId }) => {
  const logo = isCatalyst(businessUnitId) ? catalystLogo : cyLogo;
  const altText = isCatalyst(businessUnitId) ? "Catalyst" : "Codeyoung";

  return (
    <header className={styles.header}>
      <img src={logo} alt={altText} className={styles.logo} />
    </header>
  );
};

export default Header;
